export const settingsProps = {
  type: 'dashboard-settings',
  target: 'widgets',
  topWidgetsTarget: 'top-widget-settings',
}
